import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/virtual-makeup"
    exact
    path="/business/products/virtual-makeup"
    component={AsyncPage}
  />,
];
